// extracted by mini-css-extract-plugin
export default {"layout":"layout___hfG3N","well":"well___qQDrd","header":"header___R0U4C","subheader":"subheader___GG4zq","description":"description___Wd9Tu"};